import { MenuItem } from '@app/Shared/interfaces/iMenu';

export const APP_MENU_ITEMS: MenuItem[] = [
    {
        title: 'Data Explorer',
        page: '/new-data-explorer',
        iconClass: 'table_chart',
        allowedEnvs: ['dev', 'test', 'staging', 'prod'],
    },
    {
        title: 'Settings',
        page: '/settings',
        iconClass: 'settings',
        allowedEnvs: ['dev', 'test', 'staging', 'prod'],
    },
    {
        title: 'Configuration',
        page: '/configuration',
        iconClass: 'admin_panel_settings',
        allowedEnvs: ['dev', 'test', 'staging'],
    },
];

export const APP_MENU_FOOTER_ITEMS: MenuItem[] = [{ title: 'Log out', page: '/logout', iconClass: 'logout' }];
